import { useMemo } from 'react';
import moment from 'moment';
import { useWorkspace } from './useWorkspace';

export function useBilling() {
    const { billing = {} } = useWorkspace();
    const result = useMemo(() => {
        const {
            plan,
            status,
            cancelAtPeriodEnd,
            trialEnd,
            pause,
            highRiskTransaction: transaction,
            isTrialAvailable,
        } = billing;
        const hasBilling = !!billing;
        const isFree = plan === 'basic';
        const isTrial = status === 'trialing';
        const isUnpaid = status === 'unpaid';
        const isPastDue = status === 'past_due';
        const isUnlimited = plan === 'unlimited';
        const isUnsubscribed = !!cancelAtPeriodEnd;
        const trialEndedAt = isTrial && trialEnd ? new Date(billing.trialEnd) : null;
        const hasTrialEnd = !!trialEnd;
        const isPrePaused = pause && status === 'active';
        const isPaused = status === 'paused';
        const pausedFrom = pause?.pausedFrom && moment.utc(pause.pausedFrom).format('LL');
        const highRiskTransaction = isFree && ['pending', 'rejected'].includes(transaction?.status) && transaction;

        return {
            hasBilling,
            isFree,
            isTrial,
            trialEndedAt,
            plan,
            hasTrialEnd,
            isUnpaid,
            isUnlimited,
            isUnsubscribed,
            billing,
            isPastDue,
            isPrePaused,
            isPaused,
            pausedFrom,
            isTrialAvailable,
            highRiskTransaction,
        };
    }, [billing]);

    return result;
}
